import { useFormik } from "formik";
import axios from "axios";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import Layout from "../assets/component/Layout";
import { useNavigate } from "react-router-dom";

export const BASE_URL = process.env.REACT_APP_API_URL;

export default function HostelAccommodationForm() {
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            studentName: "",
            rollNumber: "",
            gender: "",
            courseYear: "",
            parentContact: "",
            medicalHistory: "",
            preferredRoomType: "",
        },
        onSubmit: async (values) => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.post(`${BASE_URL}create-hostel`, values, {
                    headers: { Authorization: token },
                });

                if (response.status === 200) {
                    navigate("/engineers-forms");
                }
            } catch (error) {
                console.error("Submission error:", error);
            }
        },
    });

    return (
        <Layout>
            <section className="Inner-page-layout">
                <div>
                    <h1>Hostel Accommodation Form</h1>
                    <div className="application-forms-cards">
                        <Container>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Student Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="studentName"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.studentName}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Roll Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rollNumber"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.rollNumber}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gender</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="gender"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.gender}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Course & Year</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="courseYear"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.courseYear}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Parent/Guardian Contact</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="parentContact"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.parentContact}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Medical History (if any)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="medicalHistory"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.medicalHistory}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Preferred Room Type (Single/Shared)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="preferredRoomType"
                                                placeholder="Type here . . ."
                                                onChange={formik.handleChange}
                                                value={formik.values.preferredRoomType}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="text-center mt-3">
                                    <Button type="submit">Save</Button>
                                </div>
                            </Form>
                        </Container>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
